import { motion } from "framer-motion";

interface CategoryItemProps {
  title: string;
  subtitle: string;
  icon: React.ReactNode;
  onClick: () => void;
  className?: string;
}

const CategoryItem = ({ title, subtitle, icon, onClick, className = '' }: CategoryItemProps) => {
  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
      className={`
        bg-white rounded-lg border border-zinc-200 p-3 cursor-pointer
        hover:border-zinc-300 hover:shadow-sm transition-all duration-200
        flex flex-col items-center text-center min-w-[90px] flex-shrink-0
        ${className}
      `}
    >
      <div className="p-2 bg-zinc-50 rounded-lg mb-2">
        {icon}
      </div>
      <div>
        <h3 className="font-medium text-zinc-900 text-xs mb-1 leading-tight">
          {title}
        </h3>
        <p className="text-[0.625rem] text-zinc-500 leading-tight line-clamp-2">
          {subtitle}
        </p>
      </div>
    </motion.div>
  );
};

export default CategoryItem;
